import React, {Component} from 'react'
import { isMobile } from 'react-device-detect';
import {toggleModal} from "../Actions/ToggleModal";
import { connect } from 'react-redux'

class Modal extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.handleESC = this.handleESC.bind(this);
        this.close = this.close.bind(this);
    }

    componentWillMount(){
        // if (!('noClose' in this.props)) {
        //     document.addEventListener('keydown', this.handleESC, false);
        // }
    }

    componentWillUnmount(){
        // if (!('noClose' in this.props)) {
        //     document.removeEventListener('keydown', this.handleESC, false);
        // }
    }

    close(){
        this.props.toggleModal(null);
    }

    handleESC(e){
        if (!('noClose' in this.props)) {
            if (e.keyCode === 27) {
                this.close()
            }
        }
    }

    handleClick(e){
        if (!('noClose' in this.props)){
            if (e.target.id === "outerModal"){
                this.close()
            }
        }
    }

    render() {
        let outerModalBackgroundColor = 'rgba(0,0,0,0.4)';

        const modalStyle =
            {
                display: 'none', /* Hidden by default */
                position: 'fixed', /* Stay in place */
                zIndex: '799', /* Sit on top */
                left: '0',
                top: '0',
                width: '100%', /* Full width */
                height: '100%', /* Full height */
                overflow: 'auto', /* Enable scroll if needed */
                // backgroundColor: 'rgb(0,0,0)', /* Fallback color */
                backgroundColor: outerModalBackgroundColor /* Black w/ opacity */
            };

        // Standard open logic is first part and for share modal is second part

        const open = this.props.modalName !== null && this.props.modalName === this.props.name

        // Open logic for share modal
        if (open){
            modalStyle.display = "block"
        }
        else{
            modalStyle.display = "none"
        }

        let footer = null;

        if ('footer' in this.props){
            footer =
                <div id="modalFooter">
                    {this.props.footer}
                </div>
        }

        let size = "large";

        if ('size' in this.props){
            size = this.props.size
        }

        if (isMobile){
            size = "full"
        }

        const sizeWidth =
            {
                small: '40%',
                medium: '60%',
                large: '80%',
                full: '100%'
            };

        const bgColor = "bodyColor" in this.props ? this.props.bodyColor : '#fefefe'

        const modalContent = {
            // marginTop: '5%',
            position: 'relative',
            backgroundColor: bgColor,
            top: '8%',
            margin: 'auto',
            padding: '0',
            // border: '1px solid white',
            borderRadius: '4px',
            width: sizeWidth[size],
            boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)',
            animationName: 'animatetop',
            animationDuration: '0.4s',
            marginBottom: '50px',
            opacity: 1
        };

        const loadingModalContent = {
            width: sizeWidth[size],
            position: 'relative',
            top: '25%',
            margin: 'auto',
            padding: '0',
            backgroundColor: 'rgba(0,0,0,0.4)' /* Black w/ opacity */
        }

        const modalBody =
            {
                padding: '15px 16px',
            };

        let close =
            <div className="closeIconClass" id="closeModalIcon" onClick={this.close}>
                <span style={{ color: bgColor === "#161E16" ? "white" : "black" }}><i className="fa-solid fa-x"></i></span>
            </div>;

        if ('noClose' in this.props){
            close = null;
        }

        if (open){
            let modalContentStyle = modalContent;
            let modalBodyStyle = modalBody;

            if (this.props.name.includes("loadingModal")){
                modalContentStyle = loadingModalContent;
                modalBodyStyle = null;
            }

            let header;

            if (typeof this.props.header === "string"){
                header = <h2 className="thinHeading"> {this.props.header}</h2>
            } else {
                header = this.props.header
            }

            return (
                <div style={modalStyle} id="outerModal" onClick={this.handleClick}>
                    <div style={modalContentStyle} id="modalContent">
                        <div style={modalBodyStyle} id="modalBody">
                            <div className="row">
                                <div className="col-sm-11">
                                    {header}
                                </div>
                                <div className="col-sm-1">
                                    {close}
                                </div>
                            </div>
                            {this.props.body}
                        </div>
                        {footer}
                    </div>
                </div>
            )
        }
        else{
            return(
                null
            )
        }
    }
}

const mapStateToProps = (state) => ({
    modalName: state.mainState.modalName
})

const mapActionsToProps = {
    toggleModal: toggleModal
}


export default connect(mapStateToProps, mapActionsToProps)(Modal)